/**
 * 描述：资源中心-我的资源-消息监控
 * 日期：2017-10-24
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('subscriptionFolderModule', [
    'myResourcesSearchModule',
    'subscriptionFolderSonModule'
])
    .controller('subscriptionFolderCtrl', ['$scope', '$state', '$element', 'globleParamsSet', 'trsspliceString', 'resourceCenterService', 'modalDialog', '$validation', '$timeout', '$q', 'myResourcesService', 'trsHttpService', 'storageListenerService', function($scope, $state, $element, globleParamsSet, trsspliceString, resourceCenterService, modalDialog, $validation, $timeout, $q, myResourcesService, trsHttpService, storageListenerService) {
        initStatus();
        initData();

        /**
     * [searchWord description] 搜索按钮
     * @return {[type]} [description]
     */
        $scope.searchWord = function() {
        // if (!$scope.status.searchWord) {
        //     modalDialog.alertType("请输入关键词！", "", "warning", false);
        //     return;
        // }
            $state.go('front.networksource.myresources.search', { searchword: $scope.status.searchWord, searchtype: $scope.status.selectedType.value });
        };

        /**
     * [create description] 创建订阅夹
     * @return {[type]} [description]
     */
        $scope.create = function() {
            $timeout(function() {
                $scope.status.showCreate = true;
                $timeout(function() {
                    $scope.status.newName = ''; // 置空新建时的input框
                    $('.new_folder').eq(0).find('input')[0].focus();
                });
            });
        };

        /**
     * [pageChanged description] 翻页
     * @return {[type]} [description]
     */
        $scope.pageChanged = function() {
            getSubscriptionFolders();
            resourceCenterService.scrollTop($element);
        };

        /**
     * [batSubscribeSource description] 修订订阅源，批量
     * @return {[type]} [description]
     */
        $scope.batSubscribeSource = function() {
            myResourcesService.subscribeSource({ id: $scope.status.selectedArray[0].id }).then(function() {
                getSubscriptionFolders();
            });
        };

        /**
     * [subscribeSource description] 修改订阅源
     * @param  {[type]} folder [description] 订阅夹
     * @return {[type]} [description]
     */
        $scope.subscribeSource = function(folder) {
            var deffer = $q.defer();
            myResourcesService.subscribeSource(folder).then(function() {
                getSubscriptionFolders();
                $state.go('front.networksource.myresources.subscriptionfolder', '', { reload: true });
                deffer.resolve();
            }, function() {
                deffer.reject();
            });
            return deffer.promise;
        };

        /**
     * [enterCreate description] 回车键创建订阅夹
     * @param  {[type]} $event [description]
     * @return {[type]}        [description]
     */
        $scope.enterCreate = function($event) {
            $($event.target).bind('keydown', function(e) {
                if (e.keyCode === 13) {
                    $scope.createSubscriptionFolder();
                }
            });
        };

        /**
     * [createSubscriptionFolder description] 失焦后的发送新建请求
     * @return {[type]} [description]
     */
        $scope.createSubscriptionFolder = function() {
            $timeout(function() {
                $validation.validate($scope.status.createForm).success(function() {
                    if ($scope.status.newName === '') {
                        $scope.status.showCreate = false;
                        return;
                    }
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'subscript',
                        modelid: 'addGroup',
                        title: $scope.status.newName
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        $scope.status.showCreate = false;
                        $scope.status.isNeedReload = true;
                        $scope.subscribeSource({ 'id': data.content[0] }).then(function() {}, function() {
                            getSubscriptionFolders();
                        });
                    });
                });
            });
        };

        /**
     * [selectFolder description] 选中订阅夹
     * @param  {[type]} folder [description] 订阅夹
     * @return {[type]}        [description]
     */
        $scope.selectFolder = function(folder) {
            var index = $scope.status.selectedArray.indexOf(folder);
            if (index >= 0) {$scope.status.selectedArray.splice(index, 1);} else {$scope.status.selectedArray.push(folder);}
        };

        /**
     * [selectItem description]   进入订阅夹详情页
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
        $scope.selectedItem = function($event, item) {
            var moduleName = 'subscriptionfolderson';
            var urlName = 'front.networksource.myresources.subscriptionfolderson';
            $state.go(urlName, { groupid: item.id }, { reload: true });
        };

        /**
     * [detailPreview description] 进入文章详情页
     * @return {[type]} [description]
     */
        $scope.detailPreview = function(guid, indexName, folder) {
            var url = $state.href('resourcedetail', { guid: guid, indexname: indexName });
            window.open(url, '_blank');
            requestListData(folder);
        };

        function requestListData(folder) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'subSearch',
                pageSize: 50,
                pageNum: 1,
                time: '-1',
                id: folder.id,
                search_type: 0
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                var listArray = [];
                if (data.result === 'success') {
                    listArray = data.content;
                }
                storageListenerService.previewPageTurningStorage(listArray, 'ZB_GUID', 'resourceDetail');
            });
        }

        /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.status = {
                showCreate: false,
                selectedArray: [],
                searchTypes: [ // 检索下拉类型
                    { name: '全部', value: '0' },
                    { name: '标题', value: '1' },
                    { name: '媒体', value: '2' },
                    { name: '正文', value: '3' }
                ],
                searchSort: [
                    { name: '常用', value: '0' },
                    { name: '按创建时间', value: '1' },
                ],
                isNeedReload: false, // 是否需要reload页面
                selectedSort: { name: '默认排序', value: '0' }
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1
            };
            $scope.data = {};
            $scope.status.selectedType = angular.copy($scope.status.searchTypes[0]);
        }

        /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
        function initData() {
            getSubscriptionFolders();
        }

        /**
     * [getSubscriptionFolders description] 获取订阅夹列表
     * @return {[type]} [description]
     */
        function getSubscriptionFolders(flag) {
            var deffer = $q.defer();
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'getGroups',
                page_num: $scope.page.CURRPAGE,
                page_size: $scope.page.PAGESIZE,
            };
            if (!!$scope.status.endDate) {
                params.time = $scope.status.startDate + ',' + $scope.status.endDate;
            }
            if (flag != undefined) {
                params.orderType = flag.value;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.list = data.content;
                $scope.status.selectedArray = [];
                $scope.page = {
                    CURRPAGE: data.page_num,
                    PAGESIZE: data.page_size,
                    PAGECOUNT: data.page_count,
                    ITEMCOUNT: data.item_count
                };
                deffer.resolve();
            });

            return deffer.promise;

        }

        /**
     * [setPushMsg description] 设置是否更新推送
     * @return {[type]} [description]
     */
        $scope.setPushMsg = function(folder) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'setPushMsg',
                id: folder.id,
                is_push_msg: folder.isPushMsg === 1 ? 0 : 1
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then((data) => {
                if (data.result == 'success'){
                    getSubscriptionFolders();
                }
            });

        };

        /** [getSubFoldersByTime description]选择时间的回调 */
        $scope.getSubFoldersByTime = function() {
            getSubscriptionFolders();
        };

        /** [getSortGroup description]在请求完数据之后 */
        $scope.getSortGroup = function() {
            getSubscriptionFolders($scope.status.selectedSort);
        };

        /**
     * [saveOrgName description] 名称备份
     * @param {[object]} [folder] [description] 订阅夹
     * @return {[type]}        [description]
     */
        $scope.saveOrgName = function(folder, index) {
            folder.orgName = folder.title;
            folder.index = index;
        };

        /**
     * [batRename description] 操作台上的重命名
     * @return {[type]} [description]
     */
        $scope.batRename = function() {
            if ($scope.status.selectedArray.length !== 1) {
                modalDialog.alertType('请选择,且只能选择一个订阅夹', '', 'warning', false);
                return;
            }
            var event = {
                target: $('#renameBtn_' + $scope.status.selectedArray[0].index)[0]
            };
            $scope.rename($scope.status.selectedArray[0], event);
        };

        /**
     * [rename description]
     * @param {[object]} [folder] [description] 订阅夹
     * @return {[type]} [description]
     */
        $scope.rename = function(folder, $event) {
            folder.editabled = true;
            $timeout(function() {
                $($event.target).parents('li').eq(0).find('form').find('input')[0].focus();
            });
        };

        /**
     * [doRename description] 发送重命名请求
     * @param {[object]} [folder] [description] 订阅夹
     * @return {[type]} [description]
     */
        $scope.doRename = function(folder, index) {
            $validation.validate($scope.status['renameForm_' + index]).success(function() {
                if (folder.orgName === folder.title) {
                    folder.editabled = false;
                    return;
                }
                if (folder.isCommon === 1) {
                    bigDataRename().then(function() {
                        wcmRename();
                    });
                } else {
                    bigDataRename();
                }

                /**
             * [wcmRename description] 创作分发重命名订阅夹
             * @return {[type]} [description]
             */
                function wcmRename() {
                    var params = {
                        serviceid: 'mlf_releaseSource',
                        methodname: 'updateMyCustom',
                        CustomId: folder.id,
                        Custom: folder.title
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {

                    });
                }

                /**
             * [bigDataRename description]
             * @return {[type]} [description]
             */
                function bigDataRename() {
                    var deffer = $q.defer();
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'subscript',
                        modelid: 'updateGroupName',
                        title: folder.title,
                        id: folder.id
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        folder.editabled = false;
                        if (data.result === 'success') {
                        // modalDialog.alertType("订阅夹重命名成功！", "", "success", false);
                            $state.go($state.current.name, '', { reload: true });
                            deffer.resolve();
                        } else {
                            folder.title = folder.orgName;
                            deffer.reject();
                        }
                    });
                    return deffer.promise;
                }
            });
        };

        /**
     * [enterRename description]
     * @param {[object]} [folder] [description] 订阅夹
     * @param  {[type]} $event [description] 事件
     * @return {[type]}        [description]
     */
        $scope.enterRename = function(folder, $event) {
            $($event.target).unbind('keydown').bind('keydown', function(e) {
                if (e.keyCode === 13) {
                    $scope.doRename(folder);
                }
            });
        };

        /**
     * [batDelete description] 批量删除订阅夹
     * @return {[type]} [description]
     */
        $scope.batDelete = function() {
            if ($scope.status.selectedArray.length === 0) {
                modalDialog.alertType('请先选择订阅夹！', '', 'warning', false);
                return;
            }
            var ids = trsspliceString.spliceString($scope.status.selectedArray, 'id', ',');
            $scope.deleteFolder(ids);
        };

        /**
     * [deleteFolder description] 删除订阅夹
     * @param {[string]} [id] [description] 订阅夹id
     * @return {[type]} [description]
     */
        $scope.deleteFolder = function(id, item) {
            modalDialog.alertType('删除订阅夹将会删除订阅夹中的所有订阅，确定删除？', '', 'ask', true, function() {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'subscript',
                    modelid: 'deleteGroup',
                    id: id
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    var flag = false, // 删除的订阅夹中过滤出常用的进行一步取消常用的操作
                        arrid = [],
                        strid = '';
                    if ($scope.status.selectedArray.length > 0) {
                        for (var i in $scope.status.selectedArray) {
                            if ($scope.status.selectedArray[i].isCommon == 1) {arrid.push($scope.status.selectedArray[i].id);}
                        }
                        strid = arrid.join(',');
                    } else {
                        if (item.isCommon == 1) {strid = item.id;} else {
                            $state.go('front.networksource.myresources.subscriptionfolder', '', { reload: true });
                            return;
                        }
                    }
                    if (data.result === 'success' && strid !== '') {
                        var wcmparams = {
                            serviceid: 'mlf_releasesource',
                            methodname: 'cancleMyCustom',
                            CustomIds: strid,
                            // Custom: name,
                            CustomType: 1
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), wcmparams, 'post').then(function(data) {
                            if (data.ISSUCCESS == 'true') {
                                $state.go('front.networksource.myresources.subscriptionfolder', '', { reload: true });
                            }
                        });
                    // modalDialog.alertType("删除订阅夹成功", "", "success", false);
                    } else {
                        $state.go('front.networksource.myresources.subscriptionfolder', '', { reload: true });
                    }
                });
            });
        };

        /**
     * [getArticleList description] 获取订阅夹文章列表
     * @param {[object]} [folder] [description] 订阅夹
     * @return {[type]} [description]
     */
        $scope.getArticleList = function(folder) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'subSearch',
                pageSize: 3,
                pageNum: 1,
                time: '-1',
                id: folder.id
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.result === 'success') {
                    folder.articleList = data.content;
                    storageListenerService.previewPageTurningStorage($scope.data.articleList, 'ZB_GUID', 'resourceDetail');
                    if (data.summary_info.indexName === undefined) {
                        $scope.indexName = data.summary_info.indexName;
                    }
                } else {
                    folder.articleList = [];
                }
            });
        };

        /**
     * [setCommon description] 设置常用
     * @param {[type]} folder [description] 订阅夹
     */
        $scope.setCommon = function(folder) {

            /* var params = {
            typeid: "zyzx",
            serviceid: "subscript",
            modelid: "setCommon",
            id: folder.id,
            is_common: folder.isCommon == 1 ? 0 : 1
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.result === "success") {
                $state.go($state.current.name, "", { reload: true });
                $(".tooltip.fade.top.in").remove();
            }
        });*/
            myResourcesService.setCommonMyResource(folder.id, folder.isCommon == 1 ? 0 : 1).then(function() {
                return myResourcesService.setCommonEditingCenter(folder.id, folder.title, folder.isCommon == 1 ? 0 : 1);
            }).then(function() {
                $state.go($state.current.name, '', { reload: true });
                $('.tooltip.fade.top.in').remove();
            });
        };

        /**
     * [dateFormat description] 时间格式化
     * @param {date} [date] [description] 日期
     * @return {[date]} [description] 日期
     */
        $scope.dateFormat = function(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        };

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };

    }]);
